import { ChildSex } from 'types';

export const childSexLabels: Record<ChildSex, string> = {
    FEMALE: 'Dziewczynka',
    MALE: 'Chłopiec',
};
